(() => {
  // node_modules/loadx/dist/loadx.module.js
  var n = function() {
    var n2 = {};
    function r(r2, t, e) {
      return new Promise(function(o, u) {
        if (t === null || !(t instanceof HTMLElement))
          return u(new Error("Parent not found."));
        var c = function(r3) {
          var t2 = JSON.stringify(r3), e2 = n2[t2];
          return e2 !== void 0 ? e2 : null;
        }(e);
        if (c !== null)
          return o(c);
        var i = document.createElement(r2);
        i.onload = function() {
          o(i), function(r3, t2) {
            var e2 = JSON.stringify(r3);
            n2[e2] = t2;
          }(e, i);
        }, i.onerror = function(n3) {
          u(new URIError("The asset " + n3.target.src + " didn't load correctly."));
        }, Object.keys(e).forEach(function(n3) {
          i[n3] = e[n3];
        }), t.appendChild(i);
      });
    }
    return r.js = function(n3) {
      return r("script", document.body, { src: n3 });
    }, r.css = function(n3) {
      return r("link", document.head, { type: "text/css", rel: "stylesheet", href: n3 });
    }, r.img = function(n3, t) {
      return r("img", function(n4) {
        return n4 === void 0 ? document.body : n4;
      }(t), { src: n3 });
    }, r;
  }();

  // src/js/components/footer.js
  var Footer = class {
    constructor(_params) {
      this.element = _params.element;
    }
    static create() {
      const params = {
        element: window.Store.app.theBody.querySelector(".js-footer")
      };
      const obj = new Footer(params);
      obj.init();
      return obj;
    }
    init() {
      const primaryNavElements = this.element.querySelectorAll(".js-footer__main-nav a");
      const secondaryNavElements = this.element.querySelectorAll(".js-footer__secondary-nav a");
      this.navElements = new Set([
        ...primaryNavElements,
        ...secondaryNavElements
      ]);
      document.addEventListener("breakpointChanged", () => this.breakpointChangedHandler());
      if (window.Store.app.activeBreakpoint !== "XXS" && window.Store.app.activeBreakpoint !== "XS" && window.Store.app.activeBreakpoint !== "SM") {
        this.toggleTabIndex("");
      }
    }
    breakpointChangedHandler(event) {
      const isMobile = window.Store.app.activeBreakpoint === "XXS" || window.Store.app.activeBreakpoint === "XS" || window.Store.app.activeBreakpoint === "SM";
      if (isMobile) {
        this.toggleTabIndex("-1");
      } else {
        this.toggleTabIndex("");
      }
    }
    toggleTabIndex(value) {
      this.navElements.forEach((element) => {
        element.setAttribute("tabindex", value);
      });
    }
  };
  function render() {
    window.Store.components.footer.obj = Footer.create();
  }
  window.Store.components.footer = {
    obj: null,
    render: null
  };
  window.Store.components.footer.render = render;
})();
